import React from 'react'

const Cookie = () => {
  return (
    <article className="grow space-y-6 md:order-2">
            <section className="">
              <div className="">
                <div className="">
                  <h2 className="uppercase font-oswald break-words text-xl md:text-2xl font-medium text-blue-800">
                    COOKIES POLICY
                  </h2>
                  <div className="mt-4 flex items-center text-grey-600">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1 h-4 w-4 flex-shrink-0"
                    >
                      <path
                        d="M8 5.33333V8L10 10M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                    <p className="font-poppins break-words text-body-xs font-normal">
                      7 months ago
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="">
              <div className="">
                <div className="">
                  <div className="quill-content">
                    <p>
                      {" "}
                      <strong> WHAT IS A COOKIE? </strong>
                    </p>
                    <p>
                      {" "}
                      <br />
                    </p>
                    <p>
                      {" "}
                      Cookies are small pieces of text sent to your browser by a
                      website you visit. They help that website remember
                      information about your visit, which can both make it
                      easier to visit the site again and make the site more
                      useful to you. Other technologies, including unique
                      identifiers used to identify a browser, app or device,
                      pixels, and local storage, can also be used for these
                      purposes. Cookies and other technologies as described
                      throughout this page can be used for the purposes
                      described below.{" "}
                    </p>
                    <p>
                      {" "}
                      <br />
                    </p>
                    <p>
                      {" "}
                      Cookies set by the website owner (NYIRENDAS IoT GROUP”
                      group companies) are called "first party cookies. Cookies
                      set by parties other than the website owner are called
                      "third party cookies". Third party cookies enable third
                      party features or functionality to be provided on or
                      through the website (e.g. like advertising, interactive
                      content, and analytics). The parties that set these
                      third-party cookies can recognize your computer both when
                      it visits the website in question and also when it visits
                      certain other websites.{" "}
                    </p>
                    <p>
                      {" "}
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="">
              <div className="">
                <div className="">
                  <div>
                    <div className="cursor-pointer select-none" tabIndex={0}>
                      <div className="duration-200 hover:bg-grey-200">
                        <div className="container undefined">
                          <div className="flex items-center justify-between border-b py-4 duration-200 md:py-8 border-grey-300 hover:border-grey-200">
                            <p className="font-inter break-words text-body-m md:text-body-l font-bold">
                              Why do we use cookies?
                            </p>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="2"
                              stroke="currentColor"
                              aria-hidden="true"
                              className="ml-2 size-6 shrink-0 duration-200"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M19 9l-7 7-7-7"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ height: "0px" }}
                      className="overflow-hidden transition-all duration-200"
                    >
                      <div className="container py-4 undefined">
                        <div className="quill-content">
                          <p>
                            {" "}
                            Some cookies are required for technical reasons in
                            order for our Websites to operate, and we refer to
                            these as "essential" or "strictly necessary"
                            cookies. Other cookies also enable us to track and
                            target the interests of our users to enhance the
                            experience on our Websites. In addition, we may use
                            these cookies or other techniques to target you with
                            interesting employer branding content. Some of the
                            cookies we use are deleted at the end of the browser
                            session, i.e. when you close your browser (known as
                            session cookies). Other cookies are kept on your end
                            device and enable us or our partner companies to
                            recognize your browser on the next visit (persistent
                            cookies).{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="cursor-pointer select-none">
                      <div className="duration-200 hover:bg-grey-200">
                        <div className="container undefined">
                          <div className="flex items-center justify-between border-b py-4 duration-200 md:py-8 border-grey-300 hover:border-grey-200">
                            <p className="font-inter break-words text-body-m md:text-body-l font-bold">
                              Cookies served through our Sites
                            </p>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="2"
                              stroke="currentColor"
                              aria-hidden="true"
                              className="ml-2 size-6 shrink-0 duration-200"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M19 9l-7 7-7-7"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ height: "0px" }}
                      className="overflow-hidden transition-all duration-200"
                    >
                      <div className="container py-4 undefined">
                        <div className="quill-content">
                          <p>
                            {" "}
                            <strong> Essential Cookies </strong>
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            These cookies are essential for the proper
                            functioning of our website. They enable such
                            features as functionality storage, which provides a
                            personalized and seamless user experience. These
                            cookies do not store any personally identifiable
                            information.{" "}
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            <strong> Analytics cookies </strong>
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            Our website uses analytics cookies to collect
                            anonymous data, allowing us to analyze website usage
                            and improve its performance. Analytics cookies help
                            us to know which pages are the most and least
                            popular and see how visitors move around the site.{" "}
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            <strong> Personalization cookies </strong>
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            Personalization cookies may be set through our site
                            by our advertising partners or our own platforms.
                            These cookies enable us to deliver targeted
                            advertisements and personalised content based on
                            your interests, enhancing your overall experience on
                            our site.{" "}
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            <strong> User data cookies </strong>
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            Sets consent for sending user personal data related
                            to advertising to Google.{" "}
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            <strong> Performance cookies </strong>
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            Performance cookies gather information about how a
                            website is used – for example, whether the user
                            receives error messages from some pages. These
                            cookies do not save information that would allow the
                            user to be identified. The collected information is
                            aggregated, and therefore made anonymous. These
                            cookies are used exclusively to improve the
                            performance of the website, and with it the user
                            experience.{" "}
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="cursor-pointer select-none" tabIndex={0}>
                      <div className="duration-200 hover:bg-grey-200">
                        <div className="container undefined">
                          <div className="flex items-center justify-between border-b py-4 duration-200 md:py-8 border-transparent">
                            <p className="font-inter break-words text-body-m md:text-body-l font-bold">
                              How to reject and (or) delete cookies?
                            </p>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="2"
                              stroke="currentColor"
                              aria-hidden="true"
                              className="ml-2 size-6 shrink-0 duration-200 rotate-180"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M19 9l-7 7-7-7"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ height: "232px" }}
                      className="overflow-hidden transition-all duration-200"
                    >
                      <div className="container py-4 undefined">
                        <div className="quill-content">
                          <p>
                            {" "}
                            We do not use any non-essential cookies without your
                            consent. Further, if you do not want websites to
                            place cookies on your computer or mobile device at
                            all, you can adapt your browser settings as such
                            that you will be notified before any cookie is
                            placed.{" "}
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            If you wish to disconnect cookies of specific
                            parties, you can do this through{" "}
                            <a
                              href=""
                              target="_blank"
                              rel="noopener noreferrer"
                              className="relative inline rounded-sm text-blue-600 ring-blue-600 ring-offset-2 ring-offset-white focus:outline-none focus-visible:ring-2 active:outline-none dark:text-white dark:ring-white dark:ring-offset-black before:absolute before:right-0 before:bottom-0 before:h-px before:w-0 before:bg-blue-600 before:duration-200 before:hover:left-0 hover:before:w-full dark:before:bg-white visited:text-purple-500 dark:visited:text-purple-500 visited:before:bg-purple-500 dark:visited:before:bg-purple-500"
                            >
                              {" "}
                              www.nyirendas.com{" "}
                            </a>
                            .
                          </p>
                          <p>
                            {" "}
                            <br />
                          </p>
                          <p>
                            {" "}
                            In addition, certain browsers provide browser
                            settings in which you can browse “incognito” or
                            “InPrivate”. Using such setting, will also enable
                            that no non-essential cookies are used.{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </article>
  )
}

export default Cookie